// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1jIqK","unreadBadge":"styles_unreadBadge__3lkTg","modalContent":"styles_modalContent__2udhU","modal":"styles_modal__1La-h"};